const GROUP_BY = ['none', 'discipline', 'type', 'project'] as const;

export type GroupBy = (typeof GROUP_BY)[number];

export function isGroupBy(value: unknown): value is GroupBy {
  return typeof value === 'string' && (GROUP_BY as readonly string[]).includes(value);
}
